























import { Vue, Component, Prop } from 'vue-property-decorator';
import { RouteNames } from './_routes';

@Component({

})
export default class FinishComponent extends Vue {
    routerNames = RouteNames;
    @Prop() data!: string;

    studentCount = '';
    sessionId = [] as any[]

    created() {
        // [this.studentCount, this.sessionId] = this.data.split(':');
        const prop = JSON.parse(this.data);
        this.studentCount = prop.id;
        this.sessionId = prop.docs;
    }

    login() {
    }

    navigateTo(page: RouteNames) {
        this.$router.push(page);
    }

}
